export const INPUT = 'input';
export const SELECT = 'select';
export const QUANTITY = 'quantity';
export const RADIOGROUP = 'radiogroup';
export const DATTEPICKER = 'datepicker';
export const CHECKBOXGROUP = 'checkboxgroup';
export const TEXTAREA = 'textarea';
export const TIMEPINKER = 'timepicker';

export const LIST = [
  INPUT,
  SELECT,
  QUANTITY,
  RADIOGROUP,
  DATTEPICKER,
  CHECKBOXGROUP,
  TEXTAREA,
  TIMEPINKER
];
